export const DEFINITION_CHANGE = 'V-UI-HUYA-HUYA_UI_EVENT-DEFINITION_CHANGE'
export const PLAYBACK_RATE_CHANGE = 'V-UI-HUYA-HUYA_UI_EVENT-PLAYBACK_RATE_CHANGE'

export const ENDED_RECOMMEND_REPLAY_BTN_CLICK = 'V-UI-HUYA-HUYA_UI_EVENT-ENDED_RECOMMEND_REPLAY_BTN_CLICK'
export const ENDED_RECOMMEND_COMMENT_BTN_CLICK = 'V-UI-HUYA-HUYA_UI_EVENT-ENDED_RECOMMEND_COMMENT_BTN_CLICK'
export const ENDED_RECOMMEND_SUBSCRIBE_BTN_CLICK = 'V-UI-HUYA-HUYA_UI_EVENT-ENDED_RECOMMEND_SUBSCRIBE_BTN_CLICK'

export default {
  DEFINITION_CHANGE,
  PLAYBACK_RATE_CHANGE,
  ENDED_RECOMMEND_REPLAY_BTN_CLICK,
  ENDED_RECOMMEND_COMMENT_BTN_CLICK,
  ENDED_RECOMMEND_SUBSCRIBE_BTN_CLICK
}
